<template>
  <div>
    <!-- 头部 -->
    <div class="new_top">
      <header2></header2>
      <navigation></navigation>
    </div>
    <!--中间主体-->
    <div class="new_content">
      <div class="new_jpkc_erji">
        <div class="new_webposition">
          <el-breadcrumb separator="/" class="nje_last">
            <el-breadcrumb-item style="float: none">精品课程</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="new_jpkc_list" id="kc">
          <div class="njl1" v-for="item in perfectCourseList">
            <div class="njl_pic"><router-link  target="_blank" :to="{ path: '/videoPlayer', query: { cId: item.id, p: true }}" ><img :src="item.imageUrl" /></router-link></div>
            <router-link target="_blank" :to="{ path: '/videoPlayer', query: { cId: item.id, p: true }}"  class="njl_text">
              <span class="njl_title textover">{{item.name}}</span>
              <span class="njl_intro">{{item.objective}}</span>
              <span class="njl_speaker">{{item.publishTime}}</span>
            </router-link>
          </div>
        </div>
        <div class="new_num_list" id="coursePageUl">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>

    </div>

    <footer1></footer1>
  </div>
</template>

<script>
  import {listPerfectCourse} from '../api/api';
  import  header2 from '../components/Header2'
  import  footer1 from '../components/Footer1'
  import  navigation from '../components/Navigation'
  export default {
    components: {
      header2,
      navigation,
      footer1
    },
    data () {
      return {
        perfectCourseList:[],
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    },
    mounted () {
      this.init();
    },
    computed: {
    },
    methods: {
      init(){
        listPerfectCourse({
          perfectPosition: this.$route.query.perfectPosition,
          orderPerfectSort: true,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((response) => {//获取精品课程
          this.perfectCourseList = response.data.data.list;
          this.total = response.data.data.total;
        })
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.init();
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.init();
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/PerfectCourseList.vue